import type { UserManager } from 'oidc-client-ts';

// Clears app storage and redirects to the auth service's end-session endpoint.
// The id_token is read *before* storage is cleared: oidc-client-ts keeps the user in
// sessionStorage, and without id_token_hint the auth service can't reliably validate
// the post-logout redirect.
export const logoutUser = async (userManager: UserManager | null | undefined): Promise<void> => {
  const user = await userManager?.getUser().catch(() => null);

  localStorage.clear();
  sessionStorage.clear();

  await userManager?.signoutRedirect({
    id_token_hint: user?.id_token,
    post_logout_redirect_uri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI,
  });
};
